<template>
  <div>
    <div id="app">
      <router-view></router-view>
    </div>

    <div id="warning-message-container">
      <div id="warning-message">
          <span class="text-center">This view is much better on laptop or iPad Pro Devices.</span>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>

@font-face {
    font-family: 'Karla';
    src: url('./assets/Karla/Karla-Regular.ttf') format("truetype");
    font-weight:300;
}

#app{
  font-family: 'Karla', sans-serif;
}

/* general css section */
.actions{
    display: flex;
    justify-content:space-between;
}
.requestActions{
    display: flex;
    justify-content:flex-end;
    margin-bottom: 20px;
}

@media screen and (max-width: 1020px) {
    #app {
        display: none;
    }
    #warning-message-container{
      display: block;
    }
    #warning-message {
      background-color: #f0f0f0;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
    }
}


@media screen and (min-width: 1024px) {
    #warning-message-container{
      display: none;
    }
    #warning-message {
      background-color: #f0f0f0;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
    }

}
/* general css section */

</style>
